<div class="travel-time-distance-btn-group">
    @for (option of options; track option) {
        <button type="button" class="btn" [ngClass]="{ 'btn-primary': value === option }" (click)="select(option)">{{ option }}</button>
    }
</div>
